import { get } from '../utils/api'

export const fetchRefListData = async (serachVal, pageIdx) => {
    try {
        const response = await get(`/reference/list?searchParam=${serachVal}&pageIdx=${pageIdx}`);
        return response;
    } catch (error) {
        console.error('오류 발생:', error);
        return [];
    };
};